import React from 'react'

const Manual_admin_empleados = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
      <div className="mt-16">
        <h2 className="font-bold xl-text-[40px] lg:text-4xl md:text-4xl text-4xl text-[#002D33] mb-5">
          Admin - Empleados
        </h2>
        <p className="text-lg text-gray-700 mb-6">
          Esta guía detalla un proceso paso a paso para la creación de usuarios que tendrán acceso al Sistema POS, asegurando una integración eficiente y una gestión efectiva dentro de su organización.
        </p>
        <iframe
          src="https://scribehow.com/embed/Admin__Empleados__0QgWL4EkTuKf0S4RTPHXew?as=scrollable"
          className="scribe-iframe-general-54"
          width="100%"
          height="6800"
          allowFullScreen
          style={{ border: 0, minHeight: '640px' }}
        ></iframe>
      </div>
    </div>
  )
}

export default Manual_admin_empleados